var _rect, _rect2, _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMedicineSuitcase = function SvgMedicineSuitcase(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 5,
    x: 5,
    y: 1,
    fill: "#FFFFFF00",
    stroke: "#c1c1c1",
    rx: 1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 12,
    x: 1,
    y: 3,
    fill: "#c1c1c1",
    stroke: "#c1c1c1",
    rx: 2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 9,
    r: 4.5,
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ff553d",
    d: "M5 8v2h2v2h2v-2h2V8H9V6H7v2z"
  })));
};
export default SvgMedicineSuitcase;